import React, { useEffect, useState, useRef, lazy } from 'react';
import { XIcon } from 'lucide-react';
const TIER1_COUNTRIES = [{
  code: 'US',
  firstNames: ['James', 'Mary', 'Robert', 'Jennifer', 'Michael', 'Linda', 'William', 'Elizabeth', 'David', 'Sarah', 'Christopher', 'Jessica', 'Daniel', 'Emily', 'Matthew'],
  lastNames: ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Miller', 'Davis', 'Wilson', 'Anderson', 'Taylor'],
  cities: ['Portland, Oregon', 'Boise, Idaho', 'Raleigh, North Carolina', 'Tampa, Florida', 'Omaha, Nebraska', 'Tucson, Arizona', 'Nashville, Tennessee', 'Milwaukee, Wisconsin', 'Sacramento, California', 'Richmond, Virginia', 'Savannah, Georgia', 'Boulder, Colorado', 'Spokane, Washington', 'Lexington, Kentucky', 'Des Moines, Iowa', 'Knoxville, Tennessee', 'Chattanooga, Tennessee', 'Baton Rouge, Louisiana', 'Asheville, North Carolina', 'Santa Fe, New Mexico']
}, {
  code: 'GB',
  firstNames: ['Oliver', 'Olivia', 'George', 'Amelia', 'Harry', 'Isla', 'Jack', 'Emily', 'Charlie', 'Mia', 'Thomas', 'Sophie', 'James', 'Grace', 'William'],
  lastNames: ['Smith', 'Jones', 'Williams', 'Taylor', 'Brown', 'Davies', 'Evans', 'Wilson', 'Thomas', 'Roberts'],
  cities: ['Bath, Somerset', 'York, North Yorkshire', 'Canterbury, Kent', 'Norwich, Norfolk', 'Exeter, Devon', 'Chester, Cheshire', 'Brighton, East Sussex', 'Oxford, Oxfordshire', 'Cambridge, Cambridgeshire', 'Stratford-upon-Avon, Warwickshire', 'Durham, County Durham', 'Salisbury, Wiltshire', 'Winchester, Hampshire', 'Harrogate, North Yorkshire', 'St Albans, Hertfordshire']
}, {
  code: 'CA',
  firstNames: ['Liam', 'Noah', 'William', 'James', 'Benjamin', 'Lucas', 'Emma', 'Olivia', 'Charlotte', 'Amelia', 'Ethan', 'Jacob', 'Logan', 'Alexander'],
  lastNames: ['Smith', 'Brown', 'Tremblay', 'Martin', 'Roy', 'Wilson', 'MacDonald', 'Taylor', 'Campbell', 'Anderson'],
  cities: ['Kelowna, British Columbia', 'Thunder Bay, Ontario', 'Red Deer, Alberta', 'Lethbridge, Alberta', 'Nanaimo, British Columbia', 'Kamloops, British Columbia', 'Chilliwack, British Columbia', 'Victoria, British Columbia', 'Halifax, Nova Scotia', "St. John's, Newfoundland", 'Moncton, New Brunswick', 'Fredericton, New Brunswick', 'Charlottetown, Prince Edward Island', 'Guelph, Ontario', 'Kingston, Ontario']
}, {
  code: 'AU',
  firstNames: ['Oliver', 'Noah', 'Jack', 'William', 'Leo', 'Henry', 'Charlotte', 'Amelia', 'Isla', 'Olivia', 'James', 'Thomas', 'Lachlan', 'Ethan', 'Cooper'],
  lastNames: ['Smith', 'Jones', 'Williams', 'Brown', 'Wilson', 'Taylor', 'Johnson', 'White', 'Martin', 'Anderson'],
  cities: ['Ballarat, Victoria', 'Toowoomba, Queensland', 'Bendigo, Victoria', 'Albury, New South Wales', 'Launceston, Tasmania', 'Mackay, Queensland', 'Rockhampton, Queensland', 'Bunbury, Western Australia', 'Bundaberg, Queensland', 'Wagga Wagga, New South Wales', 'Hervey Bay, Queensland', 'Mildura, Victoria', 'Warrnambool, Victoria', 'Gladstone, Queensland', 'Tamworth, New South Wales']
}];
const products = [{
  name: 'Complete Digital Edition',
  price: 'USD $29.97',
  image: 'https://cdn.magicpatterns.com/uploads/drsCGCcawJQmxdkJUsQyKs/Holiday_Edition_Digital_Set.png'
}, {
  name: 'Complete Digital Collection',
  price: 'USD $59.97',
  image: 'https://cdn.magicpatterns.com/uploads/drsCGCcawJQmxdkJUsQyKs/Holiday_Edition_Digital_Set.png'
}];
export const SocialProofNotificationInt02 = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState<any>(null);
  const lastCountryCodeRef = useRef<string | null>(null);
  const generateRandomNotification = () => {
    const availableCountries = TIER1_COUNTRIES.filter(c => c.code !== lastCountryCodeRef.current);
    const country = availableCountries[Math.floor(Math.random() * availableCountries.length)];
    lastCountryCodeRef.current = country.code;
    const firstName = country.firstNames[Math.floor(Math.random() * country.firstNames.length)];
    const lastName = country.lastNames[Math.floor(Math.random() * country.lastNames.length)];
    const city = country.cities[Math.floor(Math.random() * country.cities.length)];
    const product = products[Math.floor(Math.random() * products.length)];
    return {
      name: `${firstName} ${lastName}`,
      city: city,
      product: product.name,
      price: product.price,
      image: product.image
    };
  };
  useEffect(() => {
    const getRandomInterval = () => Math.floor(Math.random() * 2000) + 12000;
    const showNotification = () => {
      setCurrentNotification(generateRandomNotification());
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 12000);
    let timeoutId: ReturnType<typeof setTimeout>;
    const scheduleNext = () => {
      timeoutId = setTimeout(() => {
        showNotification();
        scheduleNext();
      }, getRandomInterval());
    };
    scheduleNext();
    return () => {
      clearTimeout(initialDelay);
      clearTimeout(timeoutId);
    };
  }, []);
  if (!currentNotification) return null;
  return <div className={`fixed z-30 transition-all duration-500 ease-out
        bottom-4 left-1/2 -translate-x-1/2
        md:bottom-5 md:left-5 md:translate-x-0
        ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'}`} data-id="element-493">
      <div className="relative backdrop-blur-md rounded-lg border shadow-[0_4px_20px_rgba(0,0,0,0.5)] p-3 flex items-center gap-3 w-[260px] sm:w-[280px]" style={{
      backgroundColor: 'rgba(11,11,11,0.95)',
      borderColor: 'rgba(255,108,0,0.3)'
    }} data-id="element-494">
        <button onClick={() => setIsVisible(false)} className="absolute top-1.5 right-1.5 transition-colors z-10" style={{
        color: 'rgba(245,245,245,0.6)'
      }} aria-label="Close notification" data-id="element-495">
          <XIcon className="h-3 w-3" data-id="element-496" />
        </button>

        <div className="flex-shrink-0" data-id="element-497">
          <div className="w-12 h-12 rounded-md overflow-hidden border border-orange-500/20" data-id="element-498">
            <img src={currentNotification.image} alt="Book" className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-499" />
          </div>
        </div>

        <div className="flex-1 min-w-0 pr-4" data-id="element-500">
          <div className="flex items-center gap-1 mb-0.5" data-id="element-501">
            <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse" data-id="element-502"></div>
            <span className="text-[10px] font-semibold text-green-400 uppercase tracking-wide" data-id="element-503">
              Just Purchased
            </span>
          </div>
          <p className="text-xs font-semibold text-white truncate" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-504">
            {currentNotification.name}
          </p>
          <p className="text-[10px] truncate" style={{
          color: 'rgba(245,245,245,0.6)',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-505">
            {currentNotification.city}
          </p>
          <p className="text-[10px] font-semibold mt-0.5" style={{
          color: '#FF6C00',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-506">
            {currentNotification.product}
          </p>
        </div>
      </div>
    </div>;
};